<template>
    <div>
        <SignStep1 v-if="currentStep == 1" @next="nextNew" @back="back" :user="user"></SignStep1>
        <SignStep2 v-if="currentStep == 2" @next="nextNew" @back="back" :user="user"></SignStep2>
        <SignStep3 v-if="currentStep == 3" @next="nextNew" @back="back" :user="user"></SignStep3>
        <SignStep4 v-if="(currentStep == 4)" @next="nextNew" @back="back" :user="user"></SignStep4>
        <SignStep5 v-if="(currentStep == 5)" @next="nextNew" @back="back" :user="user"></SignStep5>
        <SignFinished v-if="(currentStep == 6)" :link="user.pdfLink" @reset="reset"></SignFinished>
    </div>
</template>

<script>
    import SignStep3 from "./SignStep3";
    import SignStep2 from "./SignStep2";
    import SignStep1 from "./SignStep1";
    import SignStep4 from './SignStep4'
    import SignStep5 from './SignStep5'
    import SignFinished from "./SignFinished";

    export default {
        name: "TeamshootSignComponent",
        components: {SignFinished, SignStep1, SignStep2, SignStep3, SignStep4, SignStep5},
        data: () => (
            {
                currentStep: 1,
                user: {
                    fullname: '',
                    section: '',
                    type: '',
                    style: '',
                    pdfLink: '',
                    actionUrl: '',
                    portraitUrl: '',
                    signer: {
                        name: '',
                        street: '',
                        streetNr: '',
                        postcode: '',
                        city: '',
                        signature: '',
                        legalAge: ''
                    }
                }
            }
        ),
        methods: {
            async nextNew(data) {
                if(this.currentStep == 1) {
                    this.user.section = data.section
                    // TODO: Validate the data object contains the stuff from the backend
                    this.user.fullname = data.name.fullname
                    this.user.portraitUrl = data.name.portraitUrl
                    this.user.actionUrl = data.name.actionUrl
                    //
                } else if(this.currentStep == 2) {
                    this.user.type = data.type;
                } else if(this.currentStep == 3) {
                    this.user.style = data.style
                } else if(this.currentStep == 4) {
                    if (this.user.type === 'ACTION') {
                        this.user.imageNo = this.user.actionUrl.split('/images/')[1].split('.jpg')[0]
                    } else {
                        this.user.imageNo = this.user.portraitUrl.split('/images/')[1].split('.jpg')[0]
                    }
                    this.user.signer.name = data.name
                    this.user.signer.street = data.street
                    this.user.signer.streetNr = data.number
                    this.user.signer.city = data.city
                    this.user.signer.postcode = data.postcode
                } else if(this.currentStep == 5) {
                    this.user.signer.signature = data.imageData
                    this.user.signer.legalAge = data.legalAge
                    console.log(this.user)
                    const response = await this.generatePDF(this.user)
                    console.log(response)
                     if (response.data.link) {
                        this.user.pdfLink = response.data.link.split('einverstaendnis.stickerfive.shop').join('tsvploen-bestellung.stickerfive.de')
                     } else {
                        console.log('ERRORS OCCURED')
                     }

                }
                console.log(this.user)

                this.currentStep++;
            },
            async generatePDF () {
                const body = {
                    fullname: this.user.fullname,
                    section: this.user.section,
                    imageStyle: `${this.user.type}_${this.user.style}`,
                    imageData: this.user.signer.signature,
                    imageNo: this.user.imageNo,
                    signerName: this.user.signer.name,
                    signerAdress: `${this.user.signer.street} ${this.user.signer.streetNr}`,
                    signerCity: `${this.user.signer.postcode} ${this.user.signer.city}`,
                    legalAge: this.user.signer.legalAge

                    // TODO: was passiert hier mit den restlichen nutzerdaten die auf step 4 abgefragt werden?
                }

                console.log(body)
                return await this.axios.post('https://tsvploen-bestellung.stickerfive.de/backend/teamshoot/generatePdf', body)
                // @Deprecated
                // return await this.axios.post('backend/assignment', {
                //         personName: this.user.fullname,
                //         signerName: this.user.signer.fullname,
                //         signerAdress: this.user.signer.street + " " + this.user.signer.streetNr,
                //         signerCity: this.user.signer.postcode + " " + this.user.signer.city,
                //         imageData: this.user.signer.signature,
                //         legalAge: this.user.signer.legalAge
                //     })
            },
            reset() {
                this. user = {
                    fullname: '',
                    section: '',
                    type: '',
                    style: '',
                    imageNo: '',
                    pdfLink: '',
                    actionUrl: '',
                    portraitUrl: '',
                    signer: {
                        name: '',
                        street: '',
                        streetNr: '',
                        postcode: '',
                        city: '',
                        signature: '',
                        legalAge: ''
                    }
                }
                this.currentStep = 1;
            },
            back() {
                this.currentStep--;
            }
        }
    }
</script>

<style lang="scss">
    .image-type-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .input-disabled {
        //display:none;
        opacity: .5;
        pointer-events: none;
    }
    .sign-content-container {
        padding: 40px !important;
        text-align: center;
        max-height: 80vh;
        overflow-y: scroll;

        @media (max-width: 750px) {
            padding: 20px !important;
        }
    }

    .align-right {
        display: flex;
        justify-content: flex-end;
    }

    .align-left {
        display: flex;
        justify-content: flex-start;
    }


    .sf-secondary-button {
        min-width: 145px;
        min-height: 45px;
        background-color: #373737 !important;
        font-weight: bold !important;
        border: 0 !important;
        border-radius: 2px !important;
    }

    .sf-success-button {
        min-width: 145px;
        min-height: 45px;
        display: inline-flex;
        align-items: center;
        background-color: #28a745 !important;
        font-weight: bold !important;
        border: 0 !important;
        border-radius: 2px !important;
    }

    .sf-primary-button {
        min-width: 145px;
        min-height: 45px;
        display: inline-flex;
        align-items: center;
        background-color: #E8C224 !important;
        font-weight: bold !important;
        border: 0 !important;
        border-radius: 2px !important;
    }

    .sf-primary-button-outline {
        min-width: 145px;
        min-height: 45px;
        display: inline-flex;
        align-items: center;
        font-weight: bold !important;
        border: 0 !important;
        border-radius: 2px !important;
        background-color: transparent !important;
        color: #E8C224 !important;
        border: 3px solid #E8C224 !important;
    }

    .form-internal-margin {
        margin-top: 15px;
    }
    .disabled {
        pointer-events: none;
    }

    .form-margin {
        margin-top: 45px;
        @media (max-width: 564px) {
            margin-top: 25px;
        }
    }
</style>

